import { useEffect, useMemo } from "react";

import {
  MsalAuthenticationTemplate,
  useAccount,
  useMsal,
} from "@azure/msal-react";
import { AuthenticatedLayout } from "./layout/AuthenticatedLayout";
import { InteractionRequiredAuthError, InteractionType } from "@azure/msal-browser";
import { client } from "./clients/KompasApi/client.gen";
import { useApiScope } from "./shared/hooks/useApiScope";

export function App() {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const accessScope = useApiScope("Access");

  const firstAccount = useMemo(() => accounts?.[0] || null, [accounts]);

  useEffect(() => {
    const scopes = [accessScope];
  
    client.setConfig({
      auth: firstAccount
        ? () =>
            instance
              .acquireTokenSilent({
                scopes,
                account: firstAccount,
              })
              .catch((error) => {
                // If silent token acquisition fails, try interactive
                if (error instanceof InteractionRequiredAuthError)
                  return instance.acquireTokenPopup({
                    scopes,
                    account: firstAccount,
                  });
  
                throw error;
              })
              .then((tokenResponse) => tokenResponse.accessToken)
        : undefined,
    });

    instance.setActiveAccount(firstAccount);
  }, [instance, firstAccount, accessScope]);

  return (
    <MsalAuthenticationTemplate authenticationRequest={{ scopes: [accessScope] }} interactionType={InteractionType.Redirect}>
      {account && <AuthenticatedLayout />}
    </MsalAuthenticationTemplate>
  );
}
